import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type PaymentFragment = { id: string, pk: number, created: any, currency: string, capturedAmount: number, token: string, total: number, paymentVariant: Types.PaymentVariantEnum | null };

export const PaymentFragmentDoc = gql`
    fragment PaymentFragment on PaymentType {
  id
  pk
  created
  currency
  capturedAmount
  token
  total
  paymentVariant
}
    `;